export const capitalizeFirstLetter = (str) => {
    if (!str?.length) return '';
    return str?.charAt(0)?.toUpperCase() + str?.slice(1);
}

export const calculateAge = (dateOfBirth, referenceDate = new Date()) => {
    if (!dateOfBirth) return "-";

    const birthDate = new Date(dateOfBirth);
    const currentDate = new Date(referenceDate);
    if (Number.isNaN(birthDate.getTime()) || Number.isNaN(currentDate.getTime())) {
        return "-";
    }

    let age = currentDate.getFullYear() - birthDate.getFullYear();
    const monthDifference = currentDate.getMonth() - birthDate.getMonth();
    if (
        monthDifference < 0 ||
        (monthDifference === 0 && currentDate.getDate() < birthDate.getDate())
    ) {
        age -= 1;
    }

    return age >= 0 ? age : "-";
}

export const transformData = (data) => {
    const transformedData = data.map(item => [item.deviceType, item.count]);

    transformedData.unshift(["Total", "Total Users"]);

    return transformedData;
}

export const transformDataForUserType = (data) => {
    const transformedData = data?.map(item => [item.category,]);

    transformedData.unshift(["Total", "Total Users"]);

    return transformedData;
}

export const toObject = (data) => {
    const outputObject = data.reduce((acc, item) => {
        acc[item.category] = item;
        return acc;
    }, {});
    return outputObject
}

export function convertDateToFormat(dateString) {
    try {
        if (!dateString || isNaN(Date.parse(dateString))) {
            console.log("Invalid date string provided.");
        }
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    } catch (error) {
        console.error(error.message);
        return "Invalid date format.";
    }
}

export function formatNumber(number) {
    if (number >= 1_000_000_000_000) {
        return (number / 1_000_000_000_000).toFixed(2) + 'T';
    } else if (number >= 1_000_000_000) {
        return (number / 1_000_000_000).toFixed(2) + 'B';
    } else if (number >= 1_000_000) {
        return (number / 1_000_000).toFixed(2) + 'M';
    }
    return number.toString();
}
export function validateDates(startDate, endDate = null) {
    const MS_PER_DAY = 1000 * 60 * 60 * 24;
    const MAX_DAYS = 90;

    const isValidDateFormat = (dateString) => /^\d{4}-\d{2}-\d{2}$/.test(dateString);


    if (!isValidDateFormat(startDate)) {
        return { isValid: false, message: 'Start date must be in the format YYYY-MM-DD' };
    }

    if (endDate && !isValidDateFormat(endDate)) {
        return { isValid: false, message: 'End date must be in the format YYYY-MM-DD.' };
    }


    const start = new Date(startDate);
    const end = endDate ? new Date(endDate) : null;
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today.getTime() + MS_PER_DAY);

    if (isNaN(start.getTime())) {
        return { isValid: false, message: 'Invalid start date.' };
    }

    if (start > today) {
        return { isValid: false, message: 'Start date should not be in the future.' };
    }

    const startDifference = (today - start) / MS_PER_DAY;
    if (startDifference > MAX_DAYS) {
        return { isValid: false, message: 'Start date should not be older than 3 months.' };
    }

    if (end) {
        if (isNaN(end.getTime())) {
            return { isValid: false, message: 'Invalid end date.' };
        }

        if (end <= start) {
            return { isValid: false, message: 'End date should be after the start date.' };
        }

        if (end > tomorrow) {
            return { isValid: false, message: 'End date should not be tomorrow or later.' };
        }

        const endDifference = (end - start) / MS_PER_DAY;
        if (endDifference > MAX_DAYS) {
            return { isValid: false, message: 'Date range should not exceed 3 months.' };
        }
    }

    return { isValid: true, message: '' };
}

export function mergeClassNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export function convertDateTimeToFormat(dateString, format = 1) {
    try {
        if (!dateString || isNaN(Date.parse(dateString))) {
            console.log("Invalid date string provided.");
        }
        const date = new Date(dateString);
        const year = date.getFullYear();

        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
          ];
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const monthText = monthNames[date.getMonth()];

        
        const day = String(date.getDate()).padStart(2, '0');

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // convert '0' hour to '12'
        hours = String(hours).padStart(2, '0');
        if(format === 2){
            return `${day}/${month}/${year}`;
        }
        if(format === 3){
            return `${monthText} ${day}, ${year} at ${hours}:${minutes} ${ampm}`;
        }
        if(format === 4){
            return `${year}/${month}/${day} ${hours}:${minutes} ${ampm}`;
        }
        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
    } catch (error) {
        console.error(error.message);
        return "Invalid date format.";
    }
}

export function ticketName(id) {
    return `TKT-${String(id).padStart(4,'0')}`;
}

export function getDomains(){
    return   [    
        { id: 12, name: 'Jagran', domain_url : "jagran.com", avatar: 'https://www.jagranimages.com/images/wms/jagran.svg' },
        { id: 16, name: 'OMH - Tamil', domain_url : "tamil-onlymyhealth.com", avatar: 'https://www.jagranimages.com/images/wms/onlymyhealth.svg', },
        { id: 22, name: 'Jagran Josh' , domain_url: "jagranjosh.com", avatar: 'https://www.jagranimages.com/images/wms/jagran_english.svg', },  
        { id: 32, name: 'Jagran Hindi Epaper' , domain_url: "epaper.jagran.com", avatar: 'https://www.jagranimages.com/images/wms/logo/icon/epaper_jagran.svg' },
        { id: 33, name: 'Nai Dunia Epaper' , domain_url: "epaper.naidunia.com", avatar: 'https://www.jagranimages.com/images/wms/logo/icon/naidunia.svg'},
        { id: 34, name: 'Punjabi Jagran Epaper' , domain_url: "epaper.punjabijagran.com", avatar: 'https://www.jagranimages.com/images/wms/logo/icon/punjabi_jagran.svg'},
        { id: 35, name: 'Inext Live Epaper' , domain_url: "epaper.inextlive.com", avatar: 'https://www.jagranimages.com/images/wms/logo/icon/epaper_inextlive.svg'},
        { id: 36, name: 'Jagran Sakhi Epaper' , domain_url: "jagransakhi.com", avatar: 'https://www.jagranimages.com/images/wms/logo/icon/jagran_sakhi.svg'}       
    ]
}
